// extracted by mini-css-extract-plugin
module.exports = {"text":"bodyCopySkins-xlargeOnConfined-text-0ae3cdb5"};